import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@/store/Reducer'

const selectHopTimus = (state: RootState) => state.hopTimus

export const selectHopTimusIsLoading = createSelector(selectHopTimus, hopTimus => hopTimus.isLoading)

export const selectHopTimusDockAvailable = createSelector(selectHopTimus, hopTimus => hopTimus.dockAvailable)

export const selectHopTimusDockStatus = createSelector(selectHopTimus, hopTimus => hopTimus.dockStatus)

export const selectHopTimusDockUrl = createSelector(selectHopTimus, hopTimus => hopTimus.dockUrl)
